export const PDF_WIZARD = {
  // Dialog elements
  DIALOG_CLOSE_BUTTON: 'pdf-wizard-dialog-close-button',
  DIALOG_CANCEL_BUTTON: 'pdf-wizard-dialog-cancel-button',
  DIALOG_EXPORT_BUTTON: 'pdf-wizard-dialog-export-button',

  // Header section
  PROJECT_TITLE_INPUT: 'pdf-wizard-project-title-input',
  COMPARE_VERSIONS_CHECKBOX: 'pdf-wizard-compare-versions-checkbox',
  INSPECT_PATH_CHECKBOX: 'pdf-wizard-inspect-path-checkbox',

  // Page size section
  PAGE_SIZE_SELECTOR: 'pdf-wizard-page-size-selector',
  PAGE_SIZE_MENU_ITEM: 'pdf-wizard-page-size-menu-item',

  // Logo section
  LOGO_SELECTOR_DEFAULT: 'pdf-wizard-logo-selector-default',
  LOGO_SELECTOR_BANNER: 'pdf-wizard-logo-selector-banner',
  LOGO_INFO_TOOLTIP: 'pdf-wizard-logo-info-tooltip',
  OWNER_LOGO_INFO_TOOLTIP: 'pdf-wizard-owner-logo-info-tooltip',
  TIMESCALE_START_INFO_TOOLTIP: 'pdf-wizard-timescale-start-info-tooltip',
  TIMESCALE_FINISH_INFO_TOOLTIP: 'pdf-wizard-timescale-finish-info-tooltip',

  // Options section
  FIT_TO_SCREEN_CHECKBOX: 'pdf-wizard-fit-to-screen-checkbox',
  MULTI_PAGE_CHECKBOX: 'pdf-wizard-multi-page-checkbox',
  VERSION_NAME_CHECKBOX: 'pdf-wizard-version-name-checkbox',
  VERSION_DESCRIPTION_CHECKBOX: 'pdf-wizard-version-description-checkbox',
  DATA_DATE_CHECKBOX: 'pdf-wizard-data-date-checkbox',
  GENERATED_DATE_CHECKBOX: 'pdf-wizard-generated-date-checkbox'
} as const;
